var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    { Tabs__vertical: this.isVertical },
    { clearfix: this.isVertical },
    _vm.$style.container
  ],style:({ padding: _vm.padding ? _vm.padding : '' })},[_c('div',{class:_vm.$style.tabs},_vm._l((_vm.tabCount),function(tab){return _c('a',{key:tab,class:[
        _vm.activetab === tab ? 'Tabs__active' : '',
        _vm.disabledTabs.indexOf(tab) >= 0 ? 'Tabs__disabled' : '',
        _vm.dividerBeforeTab === tab ? 'Tabs__divider' : ''
      ],attrs:{"href":_vm.navigateOnClick && _vm.tabTitles && _vm.tabTitles[tab - 1].url},on:{"click":function($event){!_vm.navigateOnClick &&
          !_vm.isVertical &&
          _vm.disabledTabs.indexOf(tab) < 0 &&
          (_vm.activetab = tab)},"mouseenter":function($event){_vm.isVertical === true &&
          _vm.disabledTabs.indexOf(tab) < 0 &&
          (_vm.activetab = tab)}}},[(!_vm.tabTitles)?_vm._t((tab + "-title")):_vm._e(),(_vm.tabTitles)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.filteredTitles[tab - 1])}}):_vm._e()],2)}),0),_c('div',{class:_vm.$style.tabcontent},_vm._l((_vm.tabCount),function(tab){return _c('div',{key:tab},[(_vm.activetab === tab)?_vm._t((tab + "-content")):_vm._e()],2)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }